import Analytics from "analytics/util/Analytics";
import isApp from "shared/util/isApp";

import {
	OKCUPID_SYSTEM_USERID,
	MILLISECONDS_PER_DAY,
} from "apps/messages/util/constants";

export const getConversationAgeInDays = (timestamp) => {
	const now = Date.now();

	return Math.floor((now - timestamp) / MILLISECONDS_PER_DAY);
};

export const getMailboxLink = () => {
	const mailbox = document.getElementById("nav_mailbox");

	if (!mailbox) {
		return null;
	}

	const link = mailbox.getElementsByTagName("button");

	if (!link || !link[0]) {
		return null;
	}

	return link[0];
};

export const openProfile = (username) => {
	return () => {
		window.location.href = `/profile/${username}?cf=likes`;
	};
};

export const getMessageOpener = ({
	user,
	timestamp,
	inboxSize,
	isUnread,
	isTwoWay,
	threadid,
	onClick,
	openConversation,
	isInactive,
	history,
}) => {
	return (e) => {
		const isSiteMessage = user.id === OKCUPID_SYSTEM_USERID;

		if (!isSiteMessage) {
			const conversationAge = getConversationAgeInDays(timestamp);

			Analytics.Promos.trackMessageClick({
				match_percent: user.percentages.match,
				inbox_length: inboxSize,
				age: conversationAge,
				is_unread: isUnread,
				isTwoWay,
			});
		}

		if (typeof onClick === "function") {
			onClick();
		}

		// if you're holding the meta key (command/
		// windows), don't do anything here.
		if (e && e.metaKey) {
			return;
		}

		// New messenger can handle site messages, old messenger cannot.
		const globalMessengerCanHandle = process.env.PLATFORM === "desktop";

		if (globalMessengerCanHandle) {
			e.preventDefault();

			openConversation(user.userid);
			return;
		}
		else if (isApp()) {
			e.preventDefault();

			window.App.loadPage("/messages", {
				readmsg: true,
				threadid,
				userid: user.userid,
				isUnread: isUnread ? 1 : 0,
				hasReplied: isTwoWay ? 1 : 0,
				msg_filter: "mobile",
			});

			return;
		}

		// Hit this if we're on MW or clicking an OkC message.
		history.push(`/messages?readmsg=true&userid=${user.userid}${isInactive ? "&inactive=1" : ""}`);
	};
};



// WEBPACK FOOTER //
// ./src/apps/messages/util/helpers.js